export function updatefunctionalities(functionalities) {
  return {
    type: "@functionalities/FUNCTIONALITIES_UPDATE",
    payload: { functionalities }
  };
}
